import React from 'react'
import Form from '../Form'
import Ponnu from "./ponnu.jpg"

export default function Banner() {
  return (
    <section className="banner-area-6">
    <div className="container">
      <div className="row ">
        <div className="col-lg-7">
          <div className="banner-content wow fadeInRight" data-wow-delay="0.2s">
            <h1>Streamline all your banking and loan processes.  </h1>
            <p>Our team of experts employs a methodology to identify the top options.</p>
            <div className="d-flex flex-column flex-sm-row mt-25 subscribe-field">
              <input type='number' className="form-control me-sm-1" placeholder="Enter your phone number" />
              <a 
              onClick={()=>{
                alert("Thank you for showing interest in BankShoppy. We will get back to you soon.")
              }}
              className="input-append theme-btn theme-btn-lg ms-sm-2">Get Started</a>
            </div>
            <ul className="list-unstyled feature-list">
              <li><i className="fas fa-check-circle" /> Get 30 day free trial</li>
              <li><i className="fas fa-check-circle" /> No Spamming</li>
            </ul>
          </div>
        </div>
        <div className="col-lg-5 text-center text-lg-start">
          <div className="banner-img">
            <img className="img-1 wow fadeInLeft" data-wow-delay="0.3s" src={Ponnu} alt="" />
            {/* <img className="img-2 wow fadeInRight" data-wow-delay="0.8s" src="img/home-5/banner-img-2.png" alt="" /> */}
            <img className="img-3 wow fadeInRight" data-wow-delay="1.1s" src="img/home-5/banner-img-3.png" alt="" />
            <img className="img-shape" src="img/home-5/banner-shape.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}
